import { Controller } from "@hotwired/stimulus";

/**
 * Lazyloads heavy third-party iframe embeds (e.g. PowerBI) by copying
 * data-src into src once the element nears the viewport. Loading several
 * such embeds at once crashes low-memory devices like iOS Safari.
 *
 * Usage: <iframe data-controller="lazyload-iframe" data-src="..." ...>
 */
export default class extends Controller {
  connect() {
    if (!("IntersectionObserver" in window)) {
      this.element.src = this.element.dataset.src;
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.observer.unobserve(this.element);
            this.element.src = this.element.dataset.src;
          }
        });
      },
      { rootMargin: "200px" }
    );

    this.observer.observe(this.element);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
